export const getYesterdayDate = () => {
    const date = new Date();
    date.setDate(date.getDate()-1);
    date.setHours(0,0,0,0);
    return date.getTime();
};

export const getCurrentDate = () => {
    const date = new Date();
    return date.getTime();
};

export const getCurrentDateAtMidnight = () => {
    const date = new Date();
    return date.setHours(0,0,0,0);
};


// WEBPACK FOOTER //
// ./src/utils/date.js